import { render, staticRenderFns } from "./adminOrderTable.vue?vue&type=template&id=9fcadff4&scoped=true&"
import script from "./adminOrderTable.vue?vue&type=script&lang=js&"
export * from "./adminOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./adminOrderTable.vue?vue&type=style&index=0&id=9fcadff4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcadff4",
  null
  
)

export default component.exports